import React from 'react';

const ProfileHeader = ({ employee }) => {
  if (!employee) return null;

  // Middle name ko safely handle karne ke liye logic
  const formattedFullName = [
    employee.first_name,
    employee.middle_name,
    employee.last_name
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="profile-header-card bg-white shadow-md rounded-lg p-6 mb-6 flex flex-col md:flex-row items-center justify-between">
      <div className="flex items-center space-x-4">
        {/* Avatar / Profile Icon */}
        <div className="w-20 h-20 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-2xl font-bold">
          {employee.first_name?.[0]}{employee.last_name?.[0]}
        </div>
        
        <div>
          {/* Full Name including Middle Name */}
          <h1 className="text-2xl font-bold text-gray-800">
            {formattedFullName || employee.full_name}
          </h1>
          
          {/* Employee Code & Remarks / Designation */}
          <p className="text-sm text-gray-500">
            Emp Code: <span className="font-semibold text-gray-700">{employee.employee_code}</span>
          </p>
          
          {employee.remarks && (
            <span className="inline-block mt-2 bg-purple-100 text-purple-700 text-xs px-2.5 py-1 rounded-full font-medium">
              {employee.remarks}
            </span>
          )}
        </div>
      </div>

      {/* Status Badge */}
      <div className="mt-4 md:mt-0">
        <span className={`px-3 py-1 text-xs rounded-full font-semibold ${
          employee.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
        }`}>
          {employee.status?.toUpperCase()}
        </span>
      </div>
    </div>
  );
};

export default ProfileHeader;